var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4349_8211)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8581 1.7445C15.7308 0.956802 15.2557 0.482477 14.4903 0.374234C14.4716 0.369775 12.6076 0.012207 9.68216 0.012207C6.75757 0.012207 4.89352 0.369775 4.88095 0.372612C4.28216 0.457748 3.8646 0.764639 3.64771 1.26126C4.90127 1.12268 6.16164 1.0546 7.42284 1.05734C10.2582 1.05734 12.1446 1.38329 12.4215 1.43437C13.6697 1.62167 14.5377 2.48761 14.7477 3.75653C14.8385 4.17004 15.1255 5.62383 15.1255 7.35937C15.1255 8.28856 15.042 9.14113 14.952 9.79261C15.4466 9.58342 15.758 9.16423 15.8561 8.55856C15.8593 8.54356 16.2181 7.01234 16.2181 5.14707C16.2181 3.28221 15.8593 1.75099 15.8573 1.7441",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5988 3.95699C13.4715 3.16888 12.9959 2.69456 12.2309 2.58591C12.2123 2.58185 10.3482 2.2251 7.42324 2.2251C4.49864 2.2251 2.63418 2.58185 2.62202 2.5851C1.85053 2.69456 1.3754 3.16888 1.25013 3.94848C1.24607 3.96348 0.887695 5.49469 0.887695 7.35996C0.887695 9.22483 1.24607 10.756 1.2481 10.7625C1.3754 11.5506 1.85053 12.025 2.61594 12.1336C2.63094 12.1364 3.84026 12.3679 5.83202 12.4583L7.01905 14.5146C7.05999 14.5855 7.1189 14.6445 7.18985 14.6855C7.26081 14.7264 7.3413 14.748 7.42324 14.748C7.50517 14.748 7.58567 14.7264 7.65662 14.6855C7.72757 14.6445 7.78648 14.5855 7.82743 14.5146L9.01486 12.4587C11.0066 12.3679 12.2147 12.1369 12.2249 12.1344C12.9959 12.025 13.4715 11.5506 13.5967 10.771C13.6008 10.756 13.9588 9.22483 13.9588 7.35996C13.9588 5.49469 13.6004 3.96348 13.5988 3.95699Z",
    fill: "#121212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4349_8211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon--chat.7c62da5c319ab4fb5089e8c78d1c4293.svg";
export { ForwardRef as ReactComponent };